/* eslint-disable deprecation/deprecation */
import * as React from 'react';
import { BaseDropdownProps, DropdownType, GenericDropdownWidget } from './DropdownWidget';
import { convertMenuItemInfoToGeneric, MenuItemInfo } from './MenuItemInfo';
export { DropdownType };

export interface DropdownProps extends BaseDropdownProps {
  /** The contents of the menu as an array of MenuItemInfos */
  menuItemInfos: MenuItemInfo[];
}

/** @deprecated use `SingleSelectDropdown` */
export const DropdownWidget: React.FC<DropdownProps> = props => {
  const convertedProps = { ...props, menuItemInfos: convertMenuItemInfoToGeneric(props.menuItemInfos, props.selectedValue) };

  return React.createElement(GenericDropdownWidget, convertedProps);
};
